import { Backdrop, CircularProgress, BackdropProps } from "@mui/material";

function CustomBackDrop({ ...rest }: BackdropProps) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Backdrop className="!text-white z-50" {...rest}>
      {rest.children ? rest.children : <CircularProgress color="inherit" />}
    </Backdrop>
  );
}

export default CustomBackDrop;
